import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';
import { SecurityWarrantyBlockDesktop as SecurityWarrantyBlock } from '@alfa-bank/site-security-warranty-block/desktop';
import { LayoutDesktop } from '@alfa-bank/site-layout/desktop';
import { Email } from '@alfa-bank/site-form-email';
import { FormDesktop } from '@alfa-bank/site-form/desktop';
import { FormBirthday as Birthday } from '@alfa-bank/site-form-birthday';
import { RadioTagsDesktop } from '@alfa-bank/site-radio-tags/desktop';
import { X5BankButton as Button } from '@alfa-bank/site-x5-bank-button';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { Link } from '@alfa-bank/site-link';
import { DcDraftDesktop } from '@alfa-bank/site-dc-draft/desktop';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { X5BankPhoneInput } from '@alfa-bank/site-x5-bank-phone-input';

import { FormAgreementDesktop } from '../components/agreement-form/desktop';
import { ProgressDesktop } from '../components/progress/desktop';
import { PromoCode } from '../components/promo-code';
import { StickyMobile } from '../components/sticky-mobile';
import { X5BankForm as Component } from '../form';
import { useVisibilityChecker } from '../utils/hooks';
import type { TX5BankFormShort, IDeps } from '../models';
import { FioFieldDesktop as FioField } from '../components/fio/desktop';
import styles from '../styles/styles.css';
import { HeadingDesktop as Heading } from '../components/heading/desktop';
import { ACTION_PATH } from '../config';

export const X5BankFormDesktop = createWidget<IDeps, TX5BankFormShort>(
    {
        Heading,
        PromoCode,
        Grid,
        SecurityWarrantyBlock,
        Layout: LayoutDesktop,
        Agreement: FormAgreementDesktop,
        Email,
        FioField,
        Phone: X5BankPhoneInput,
        Progress: ProgressDesktop,
        Form: FormDesktop,
        Birthday,
        RadioTags: RadioTagsDesktop,
        DcDraft: DcDraftDesktop,
        Text,
        Link,
        Button,
        useNamedContainers,
        sendEvent,
        useVisibilityChecker,
        StickyMobile,
        styles,
        actionPath: ACTION_PATH,
    },
    { priorityStyler: true }
)(Component);
